import {useIntl} from 'react-intl';
import {Center, Heading, Text} from '@chakra-ui/react';

import {useTranslate} from '@eksab/i18n';
import type {CoinsPackage} from '@eksab/features/store/types';

import {DiscountBadge} from './';
import {useRegionSettings} from '@eksab/hooks';

type PackageDetailsProps = {
  pack: CoinsPackage;
};

export const PackageDetails = ({pack}: PackageDetailsProps) => {
  const formatNumber = useIntl().formatNumber;

  const t = useTranslate();

  const {data: regionSettings} = useRegionSettings();

  return (
    <Center flexDir="column">
      <Heading
        fontSize={{base: 'clamp(0.8rem, 4vw, 1.4rem)', lg: 'xl', xl: '2rem'}}
        textTransform="lowercase"
        noOfLines={1}
      >
        {formatNumber(pack.coins)} {t('app.coins')}
      </Heading>

      <Text fontSize={{base: 'clamp(0.8rem, 3.3vw, 1.1rem)', lg: 'lg'}} mt={[-0.5, 0, 1]}>
        {t('store.coins.for', {
          price: (
            <Text as="span" fontWeight={pack.price.discount ? 700 : 500}>
              {formatNumber(pack.price.discounted)} {regionSettings?.currency}
            </Text>
          ),
        })}
      </Text>

      {!!pack.price.discount && (
        <>
          <Text as="del" fontSize={{base: 'clamp(0.8rem, 3.3vw, 1.1rem)', lg: 'lg'}} mt="-0.5">
            {formatNumber(pack.price.original)} {regionSettings?.currency}
          </Text>

          <DiscountBadge discount={pack.price.discount} />
        </>
      )}
    </Center>
  );
};
